"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQueryParams = void 0;
const react_router_dom_1 = require("react-router-dom");
// A custom hook that builds on useLocation to parse
// the query string for you.
// Source: https://reactrouter.com/web/example/query-parameters
const useQueryParams = () => {
    return new URLSearchParams((0, react_router_dom_1.useLocation)().search);
};
exports.useQueryParams = useQueryParams;
//# sourceMappingURL=useQueryParams.js.map